import styled from 'styled-components';
import SearchSvg from 'library/icons/search.svg';
import FilterSvg from 'library/icons/filter.svg';
import SortSvg from 'library/icons/sort.svg';

export const ControlsContainer = styled.div`
  font-size: 1.5em;
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  div:last-child {
    margin-right: unset;
  }
`;

export const ToolTipContainer = styled.div`
  font-size: 1.5em;
  display: flex;
`;

export const SearchIcon = styled(SearchSvg)`
  color: ${(props) => props.theme.colors.teal300};
  font-size: 1.2em;
  ${(props) => (props.isTabbing ? '' : 'outline: none;')}
`;
export const FilterIcon = styled(FilterSvg)`
  font-size: 1.2em;
  width: 1em;
  height: 1em;
`;
export const SortIcon = styled(SortSvg)`
  font-size: 1.2em;
  width: 1em;
  height: 1em;
`;

export const StyledSearchContainer = styled.div`
  width: auto;
`;

export const StyledSearchInnerContainer = styled.div`
  display: inline-flex;
  align-items: center;

  label {
    font-size: 14px;
  }

  input {
    padding-right: 2em;
  }

  ${SearchIcon} {
    margin-left: -1.5em;
    z-index: 1;
    font-size: 0.8em;
  }
`;

export const StyledToolTipLabel = styled.span`
  visibility: hidden;
  font-size: 18px;
  background-color: ${(props) => props.theme.colors.blue400};
  color: ${(props) => props.theme.colors.yellow050};
  text-align: center;
  border-radius: 6px;
  padding: 5px;
  position: absolute;
  z-index: 1;
  top: 120%;

  &::after {
    content: '';
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent
      ${(props) => props.theme.colors.blue400} transparent;
  }
`;

export const StyledToolTip = styled.div`
  display: flex;
  position: relative;
  margin: 0 0.25em;
  padding: 0 0.5em;
  @media (min-width: ${(props) => props.theme.screen.tablet}px) {
    &:hover ${StyledToolTipLabel} {
      visibility: visible;
    }
    &:hover {
      width: 2em;
      height: 2em;
      border-radius: 50%;
      background-color: ${(props) => props.theme.colors.grey300};
      align-items: center;
      justify-content: center;
      display: flex;
    }
  }
  ${(props) => (props.isTabbing ? '' : 'outline: none;')}
`;
